import { Button } from 'components/button/Button'
import { DirectiveCard } from 'components/directive/directiveCard/DirectiveCard'
import { DirectiveListEmptyState } from 'components/directive/directiveListEmptyState/DirectiveListEmptyState'
import { Stack } from 'components/Stack'
import { SWizardGrid } from 'components/wizard/wizardGridCard/WizardGridCard'
import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'
import { SWRInfiniteResponse } from 'swr/infinite/dist/infinite'
import { FetchResponse } from 'utils/fetcher'
import { getPaginationMeta } from 'utils/pagination'
import { ApiType } from 'utils/types'

export const DirectiveList = ({
  directiveSwr,
  emptyStateDescription,
  emptyStateTitle,
}: {
  directiveSwr: SWRInfiniteResponse<
    FetchResponse<ApiType['PaginatedResponseUserDirectiveResponse']>
  >
  emptyStateTitle: string
  emptyStateDescription: string
}) => {
  const { t } = useTranslation()
  const meta = getPaginationMeta(directiveSwr)

  if (meta.isEmpty)
    return <DirectiveListEmptyState title={emptyStateTitle} description={emptyStateDescription} />

  return (
    <Stack space={'1.5rem'}>
      <div css={{ width: '100%' }}>
        {!meta.isLoadingInitial && (
          <SWizardGrid multiRow>
            {directiveSwr.data?.map((page, pageIndex) => (
              <Fragment key={pageIndex}>
                {page?.json?.items?.map((item) => {
                  return (
                    <DirectiveCard
                      directive={item}
                      key={item.uuid}
                      onDataChange={directiveSwr.mutate}
                    />
                  )
                })}
              </Fragment>
            ))}
          </SWizardGrid>
        )}
      </div>

      {!meta.isReachingEnd && (
        <Button
          type="button"
          variant="secondary"
          size="large"
          block
          loading={meta.isLoadingMore}
          onClick={meta.handleLoadMore}
        >
          {t('common.load_more')}
        </Button>
      )}
    </Stack>
  )
}
